import React from "react";
import { Link } from "react-router-dom";
import "./Button.css";
// import Breadcrumb from '../../../Layout/Breadcrumb/Breadcrumb';
// import Header from '../../../Layout/Header/Header';
// import Footer from '../../../Layout/Footer/Footer';
// import Nav from '../../../Layout/Nav/Nav';
// import LoginImage from '../../../Images/login.jpg';

function Button(props) {
  //   const [iconButtonsStore, seticonButtonsStore] = useState(iconButtons);

  const buttons = [
    {
      id: 1,
      name: "add",
      button: (
        <Link
          to={props.urlto}
          type="button"
          className="button-elmt button-elmt-add"
        >
          <div className="button-elmt-c-sec">
            <svg
              className="button-elmt-c-icon-elmt"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 448 512"
            >
              <path d="M256 80c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 144L48 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l144 0 0 144c0 17.7 14.3 32 32 32s32-14.3 32-32l0-144 144 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-144 0 0-144z" />
            </svg>
            <span className="button-elmt-t">{props.title}</span>
          </div>
        </Link>
      ),
    },

    {
      id: 2,
      name: "assign",
      button: (
        <Link
          to={props.urlto}
          type="button"
          className="button-elmt button-elmt-import"
        >
          <div className="button-elmt-c-sec">
            <svg
              className="button-elmt-c-icon-elmt"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 512 512"
            >
              <path d="M16 288c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h112v-64zm489-183L407.1 7c-4.5-4.5-10.6-7-17-7H384v128h128v-6.1c0-6.3-2.5-12.4-7-16.9zm-153 31V0H152c-13.3 0-24 10.7-24 24v264h128v-65.2c0-14.3 17.3-21.4 27.4-11.3L379 308c6.6 6.7 6.6 17.4 0 24l-95.7 96.4c-10.1 10.1-27.4 3-27.4-11.3V352H128v136c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H376c-13.2 0-24-10.8-24-24z"></path>
            </svg>
            <span className="button-elmt-t">{props.title}</span>
          </div>
        </Link>
      ),
    },

    {
      id: 3,
      name: "update",
      button: (
        <Link
          to={props.urlto}
          type="button"
          className="button-elmt button-elmt-update"
        >
          <div className="button-elmt-c-sec">
            <svg
              class="button-elmt-c-icon-elmt"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 512 512"
            >
              <path d="M471.6 21.7c-21.9-21.9-57.3-21.9-79.2 0L362.3 51.7l97.9 97.9 30.1-30.1c21.9-21.9 21.9-57.3 0-79.2L471.6 21.7zm-299.2 220c-6.1 6.1-10.8 13.6-13.5 21.9l-29.6 88.8c-2.9 8.6-.6 18.1 5.8 24.6s15.9 8.7 24.6 5.8l88.8-29.6c8.2-2.7 15.7-7.4 21.9-13.5L437.7 172.3 339.7 74.3 172.4 241.7zM96 64C43 64 0 107 0 160L0 416c0 53 43 96 96 96l256 0c53 0 96-43 96-96l0-96c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 96c0 17.7-14.3 32-32 32L96 448c-17.7 0-32-14.3-32-32l0-256c0-17.7 14.3-32 32-32l96 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L96 64z"></path>
            </svg>
            <span className="button-elmt-t">{props.title}</span>
          </div>
        </Link>
      ),
    },

    {
      id: 4,
      name: "back",
      button: (
        <Link
          to={props.urlto}
          type="button"
          className="button-elmt button-elmt-back"
        >
          <div className="button-elmt-c-sec">
            <svg
              class="button-elmt-c-icon-elmt"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 320 512"
            >
              <path d="M41.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.3 256 246.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z"></path>
            </svg>
            <span className="button-elmt-t">{props.title}</span>
          </div>
        </Link>
      ),
    },

    {
      id: 5,
      name: "close",
      button: (
        <Link
          to={props.urlto}
          type="button"
          className="button-elmt button-elmt-cancel"
        >
          <div className="button-elmt-c-sec">
            <svg
              className="icon-button-elmt-c-icon-elmt"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 384 512"
            >
              <path d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"></path>
            </svg>
            <span className="button-elmt-t">{props.title}</span>
          </div>
        </Link>
      ),
    },

    {
      id: 6,
      name: "save",
      button: (
        <Link
          to={props.urlto}
          type="button"
          className="button-elmt button-elmt-save"
        >
          <div className="button-elmt-c-sec">
            <svg
              class="button-elmt-c-icon-elmt"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 448 512"
            >
              <path d="M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-242.7c0-17-6.7-33.3-18.7-45.3L352 50.7C340 38.7 323.7 32 306.7 32L64 32zm0 96c0-17.7 14.3-32 32-32l192 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32L96 224c-17.7 0-32-14.3-32-32l0-64zM224 288a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"></path>
            </svg>
            <span className="button-elmt-t">{props.title}</span>
          </div>
        </Link>
      ),
    },

    {
      id: 7,
      name: "save-invoice",
      button: (
        <Link
          to={props.urlto}
          type="button"
          className="button-elmt button-elmt-save-invoice"
        >
          <div className="button-elmt-c-sec">
          <svg class="button-elmt-c-icon-elmt" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path d="M64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-288-128 0c-17.7 0-32-14.3-32-32L224 0 64 0zM256 0l0 128 128 0L256 0zM80 64l64 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L80 96c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64l64 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zm16 96l192 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32L96 352c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32zm0 32l0 64 192 0 0-64L96 256zM240 416l64 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16s7.2-16 16-16z"/></svg>
            <span className="button-elmt-t">{props.title}</span>
          </div>
        </Link>
      ),
    },

    {
      id: 8,
      name: "update-invoice",
      button: (
        <Link
          to={props.urlto}
          type="button"
          className="button-elmt button-elmt-update-invoice"
        >
          <div className="button-elmt-c-sec">
          <svg class="button-elmt-c-icon-elmt" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path d="M64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-288-128 0c-17.7 0-32-14.3-32-32L224 0 64 0zM256 0l0 128 128 0L256 0zM80 64l64 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L80 96c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64l64 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zm16 96l192 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32L96 352c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32zm0 32l0 64 192 0 0-64L96 256zM240 416l64 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16s7.2-16 16-16z"/></svg>
            <span className="button-elmt-t">{props.title}</span>
          </div>
        </Link>
      ),
    },
  ];

  return buttons
    .filter((ibtn) => ibtn.name == props.btnname)
    .map((filteredIbtn) => (
      <span key={filteredIbtn.id}>{filteredIbtn.button}</span>
    ));
}
export default Button;
